import ClientAdmin from "./clients"
import { Consumer, Provider, ClientsContext } from "./clients.context"

export { Consumer, Provider, ClientsContext }
export { default as ClientsPanel } from "./clients.panel"
export default ClientAdmin
